import ArrayUtil from "Pub/js/arrayUtil";

export class GridLayoutAction {
    constructor(props) {
        this.layouts = new ArrayUtil(props.layouts);
        this.groupIndex = props.groupIndex;
        this.setLayouts = props.setLayouts;
    }

    /**
     * 在末尾添加GridItem
     *
     * @param {*} newItems 添加GridItem信息
     * @param {*} position 添加GridItem的位置index
     */
    add(newItems, position) {
        let newLayouts = this.layouts.add(newItems);
        if (position !== undefined) {
            newLayouts = this.layouts.insert(position, newItems);
        }
        this.updateLayout(newLayouts);
    }

    /**
     * 删除指定GridItem
     *
     * @param {*} index 删除GridItem的index
     */
    remove(index) {
        const layouts = this.layouts.remove(index);
        this.updateLayout(layouts);
    }

    /**
     * 根据id删除指定GridItem
     *
     * @param {*} id 删除GridItem的id
     */
    removeById(id, appGroupId) {
        const ids = Array.isArray(id) ? id : [id];
        let layouts = this.layouts.getArray();
        let removeItem; // 删除的item
        for (let i = 0; i < ids.length; i++) {
            const removeIndex = layouts.findIndex(item => item.cardid === ids[i]);
            if(removeIndex !== -1) {
                removeItem = layouts[removeIndex];
                this.layouts.remove(removeIndex);
                layouts.splice(removeIndex, 1);
            }
        }
        if (appGroupId) { // 说明是桌面应用拖进了聚合应用，需要更新聚合应用侧拉
            const appGroupItem = layouts.find(item => item.cardid === appGroupId);
            if (appGroupItem && appGroupItem.sideData.cardList) {
                appGroupItem.sideData.cardList.push(removeItem);
            }
        }
        this.updateLayout(layouts);
    }

    //更新store
    updateLayout(data) {
        this.setLayouts(this.groupIndex, data);
    }

    /**
     * 根据react-grid-layout的layout更新item的位置、大小
     *
     * @param {*} layout GridLayout的布局
     * @param {*} targetItem 操作的GridItem信息
     */
    update(layout, targetItem) {
        let newLayouts = this.layouts.getArray();
        newLayouts = newLayouts.map((item) => {
            let target = layout.find((l) => item.cardid === l.i) || {};
            if (targetItem !== undefined && targetItem.i === item.cardid) {
                target = { ...targetItem };
            }
            const itemObj = { gridx: target.x, gridy: target.y, width: target.w, height: target.h };
            return { ...item, ...itemObj };
        });
        this.updateLayout(newLayouts);
    }

    /**
     * 根据id获取GridItem信息
     *
     * @param {*} id GridItem的id
     */
    findById(id) {
        let layouts = this.layouts.getArray();
        return layouts.find(item => item.cardid === id);
    }
}
